export const SHOW_TEXT = "SHOW_TEXT";
export const RESPONSE_ERROR = "RESPONSE_ERROR";

export const USER_EDITED = "USER_EDITED";
export const USER_CREATED = "USER_CREATED";
export const USERS_SEARCHED = "USERS_SEARCHED";
export const USER_CURRENT = "USER_CURRENT";

export const SEARCH_REALIZED = "SEARCH_REALIZED";
